import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SidebarItem } from './sidebar.models';
import { IconComponent, TooltipDirective } from '@ui';
import { StatusIndicatorComponent } from './status-indicator.component';

@Component({
  selector: 'ui-sidebar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, StatusIndicatorComponent, TooltipDirective],
  template: `
    @if (item()) {
      @if (!item()?.hidden) {
        <div
          class="flex flex-row items-start justify-start gap-x-2 bg-transparent"
        >
          @if (item()?.icon) {
            <ui-icon [icon]="item()!.icon" class="text-md text-gray-400" />
          }

          <div class="mt-2.5">
            <ui-sidebar-item-status-indicator
              [status]="item()?.statusIndicator || null"
            />
          </div>

          <div class="flex flex-col justify-start items-start gap-y-0 gap-x-2">
            <div
              uiTooltip
              [tooltipTitle]="item()?.tooltip ? tooltipTitleTemplate : null"
              [tooltipTitleContext]="{ $implicit: item() }"
            >
              <span
                class="block text-xs"
                [class]="{
                  'font-bold': itemStatus() === 'active',
                  'text-primary': itemStatus() === 'default',
                  'text-gray-400': itemStatus() === 'disabled',
                }"
              >
              {{ item()?.id }} {{ item()?.id ? (item()?.entity ? '-' : '') : '' }} {{ item()?.entity }}
              </span>
            </div>

            @if (item()?.subId) {
              <div
                class="flex flex-row items-center gap-x-1 "
                [class]="{
                  'text-gray-500': itemStatus() === 'default',
                }"
              >
                <ui-icon
                  icon="icons:form-input"
                  class="text-md block"
                />
                <span class="text-xxs block">{{
                  item()?.subId
                }}</span>
              </div>
            }

          </div>
        </div>
      } @else {
        <!-- No content -->
        @if (item()?.icon) {
          <ui-icon [icon]="item()!.icon" class="text-md text-gray-400" />
        }
      }
    }

    <ng-template #tooltipTitleTemplate let-data>
      <div class="flex flex-col items-center text-xs mt-0.5">
        <span>{{ data.tooltip }}</span>
      </div>
    </ng-template>
  `,
})
export class SidebarItemComponent {
  item = input<SidebarItem>();
  itemStatus = computed<'active' | 'disabled' | 'default'>(() =>
    this.getItemStatus(this.item()),
  );

  private getItemStatus(item?: SidebarItem) {
    if (item?.disabled) return 'disabled';
    if (item?.active || item?.selected) return 'active';
    return 'default';
  }
}
